<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { sidebarGroupedRoute } from '@/libs/utils.js'

import configuration from '@/provider/configuration.js'

const route = useRoute()
const router = useRouter()

const isLoading = ref(true)
const openGroups = ref([])
const appName = ref(null)
const sidebarRoutes = ref([])

const isGroupOpen = (group) => openGroups.value.includes(group)
const toggleGroup = (group) => {
  if (isGroupOpen(group)) {
    openGroups.value = openGroups.value.filter((g) => g !== group)
  } else {
    openGroups.value.push(group)
  }
}

onMounted( () => {
  appName.value = configuration.getConfig()['app']['name']
  sidebarRoutes.value = sidebarGroupedRoute(router)
  openGroups.value = Object.keys(sidebarRoutes.value)
})

</script>

<template>
  <aside
    class="app-sidebar main-sidebar d-print-none sidebar-light-primary footer-fix overflow-visible bg-white"
  >

    <div class="user-panel">
      <nav>
        <ul
          class="nav nav-pills nav-sidebar flex-column overflow-hidden"
          data-lte-toggle="treeview"
          role="menu"
          data-accordion="false"
        >
          <li class="nav-item has-treeview">
            <a
              id="navBarToggle"
              data-lte-toggle="sidebar"
              class=" nav-link font-weight-bold"
              href="#"
              role="button"
              @click="$emit('toggle-sidebar')"
            >
              <div class="hide-collapsed d-flex justify-content-between align-content-center">
                <h4 class="module-color text-uppercase mb-0 float-start module-title ps-0">
                  {{ appName }}
                </h4>
                <i class="end fas fa-arrow-left close-sidebar-icon text-dark float-end"></i>
              </div>
              <div class="show-collapsed d-none text-center">
                <i class="fas fa-bars close-sidebar-icon text-dark"></i>
                <br>
                <span class="menu-word">MENU</span>
              </div>
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <div class="sidebar-wrapper p-0 hide-collapsed bg-white">
      <nav>
        <ul
          class="nav sidebar-menu flex-column nav-pills nav-sidebar nav-treeview"
          data-lte-toggle="treeview"
          role="menu"
          data-accordion="false"
        >
          <template v-for="(group, index) in sidebarRoutes" :key="index">
            <li :class="['nav-item ', { 'menu-open': isGroupOpen(index) }]">
              <a href="javascript:void(0)"
                 @click="toggleGroup(index)"
                 class="nav-link title text-uppercase hide-on-scrollbar-close menu-list text-overline">
                <div class="m-0 ps-0 d-flex justify-content-between align-content-center align-items-center w-100 text-12px">
                  {{ index }}
                  <i
                    :class="['fas', { 'fa-angle-down': isGroupOpen(index), 'fa-angle-left': !isGroupOpen(index) }]"></i>
                </div>
              </a>
              <ul class="nav nav-treeview">
                <li class="nav-item" v-for="(item, i) in group" :key="i">
                  <router-link
                    :to="{ name: item.name }"
                    :class="
                  'hide-on-scrollbar-close nav-link page ' +
                  ( route &&
                    route.name &&
                  (route.name === item.name ||
                    route.name.indexOf(item.name) === 0)
                    ? ' active'
                    : '')
                "
                  >
                    {{ item.meta.title }}
                  </router-link>
                </li>
              </ul>
            </li>
          </template>
        </ul>

      </nav>
    </div>
  </aside>

  <div class="sidebar-overlay" @click="$emit('toggle-sidebar')"></div>

</template>
